import { Center, ContactShadows, Environment, Float, OrbitControls, PresentationControls } from '@react-three/drei'
import { useControls } from 'leva'
import Bicycle from './components/Bicycle'

export default function Experience() {

    const { bgColor } = useControls('Envrionment', {
        bgColor: "#e5baa0"
    })

    return <>

        {/* Bacground color. */}
        <color args={[bgColor]} attach="background" />

        <Environment preset='city' />

        {/* <OrbitControls makeDefault /> */}

        <PresentationControls
            global
            // rotation={[0, 0.1, 0]}
            polar={[-0.4, 0.2]}
            azimuth={[-1, 0.75]}
            config={{ mass: 2, tension: 400 }}
            snap={{ mass: 4, tension: 400 }}
        >
            <Center>
                {/* <Float rotationIntensity={0.4}> */}
                <Bicycle />
                {/* </Float> */}
            </Center>
        </PresentationControls>





        <ContactShadows
            position-y={-1.3}
            opacity={0.4}
            scale={5}
            blur={2.4}
        />

    </>
}